import { CostBuyModelType } from '@teinor/erp/types/company/config/cost/costBuy'

export interface CostsBuysAction {
    type: 'CHANGE_COSTSBUY'
    payload: CostBuyModelType[]
}
export type CostBuyPayload = { active: { [id: number]: CostBuyModelType }, all: { [id: number]: CostBuyModelType } } | null

export default function costsBuy(state: CostBuyPayload = null, action: CostsBuysAction): CostBuyPayload {
    switch (action.type) {
        case 'CHANGE_COSTSBUY':
            let costsbuys: CostBuyPayload = {
                active: {},
                all: {}
            }
            for (const element of action.payload) {
                if (element.active) {
                    costsbuys.active[element.id] = element
                }
                costsbuys.all[element.id] = element
            }
            return state = costsbuys
        default:
            return state
    }
}